<script>
    import app from "../../stores/app";
    import {fade, fly} from 'svelte/transition';
    import {clickOutside} from "../../lib/clickOutside";
    import {createEventDispatcher} from 'svelte/internal';
    import CloseButton from "../../components/CloseButton.svelte";

    export let title = '';

    export let modalSm = false;
    export let modalMd = false;
    export let modalXl = false;
    export let showCloseButton = true;
    export let closeOnClickOutside = false;
    export let closeOnEscape = true;
    export let visible = true;
    export let bodyClass = '';
    export let onBeforeClose = null;

    let nowState = false;

    const dispatch = createEventDispatcher();

    const handleClickOutside = () => {
        if (closeOnClickOutside) {
            close();
        }
    }

    const close = () => {
        let doClose = true;
        if (onBeforeClose != null) {
            doClose = onBeforeClose();
        }

        if (!doClose) {
            return;
        }

        visible = false;
        if (closeOnEscape) {
            app.removeEscapeEventHandler();
        }
        setTimeout(() => {
            dispatch('close');
        }, 200);
    }

    $: if (nowState != visible && closeOnEscape) {
        if (visible) {
            if (closeOnEscape) {
                app.addEscapeEventHandler(close);
            }
            nowState = visible;
        }
    }
</script>
{#if visible}
    <div class="modal-overlay" id="moooodal" transition:fade="{{ duration: 100 }}" use:clickOutside
         on:click_outside="{ handleClickOutside }">
        <div class="wrapper" class:full-screen={modalXl}>
            <div class="panel modal-panel" class:modal-sm={ modalSm } class:modal-md={ modalMd } class:modal-xl={modalXl} in:fly="{{ y: -20, duration: 200 }}">
                <div class="panel-heading panel-pad">
                    <div class="title">
                        { title }
                    </div>
                    {#if showCloseButton}
                        <CloseButton on:click="{ close }"/>
                    {/if}
                </div>
                <div class="panel-body panel-pad { bodyClass }">
                    <slot name="body"/>
                </div>
                <slot name="footer"/>
            </div>
        </div>
    </div>
{/if}

<style>
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9000;
        overflow-y: auto;
    }

    .modal-overlay .wrapper {
        position: absolute;
        width: 100%;
        padding: 10px 0;
    }

    .modal-panel {
        width: max-content;
        background: #fff;
        border-radius: 2px;
        padding-top: 5px;
        transition: .3s all ease;
        margin: 0 auto;
        overflow: hidden;
    }

    .modal-overlay .wrapper.full-screen {
        padding: 10px;
    }

    .modal-sm {
        width: 100%;
        max-width: 350px;
    }

    .modal-md {
        width: 800px;
    }

    .modal-xl {
        width: 100%;
        min-height: calc(100vh - 20px);
    }

    @media (max-width: 576px) {
        .modal-panel {
            width: calc(100vw - 20px);
        }
    }

    @media (min-width: 768px) and (max-width: 991px) {
        .modal-md {
            width: calc(100% - 20px);
        }
    }

    @media (min-width: 992px) {
        .modal-panel {
            min-width: 450px;
        }

        .modal-sm {
            min-width: unset;
        }
    }

    @media (min-width: 1200px) {
        .modal-overlay .wrapper {
            padding: 30px 0;
        }
    }
</style>